module.exports = __webpack_public_path__ + "static/media/login-main-img.03668692.svg";